import React, { Component } from "react";
import { object, func } from "prop-types";
import BloxButton from "sub_components/Common/BloxButton";
import TextInput from "sub_components/Common/BloxTextInput";
import { INPUT_TYPES } from "utils/CommonConstants";
import { RESOLUTIONS as BREAKPOINTS } from "services/config";
import UploadSection from "sub_components/Common/UploadSection";
import { TICKET_ATTACHMENT_PHASE as PHASE } from "utils/TicketConstants";

const CDN_URL = process.env.REACT_APP_CDN_URL;

const LowPrioritySelected = `${CDN_URL}support/ticketing/low-priority-selected-lg.svg`;
const MediumPrioritySelected = `${CDN_URL}support/ticketing/medium-priority-selected-lg.svg`;
const HighPrioritySelected = `${CDN_URL}support/ticketing/high-priority-selected-lg.svg`;

const MAX_TEXT_AREA_HEIGHT = {
  [BREAKPOINTS.LOW]: 104,
  [BREAKPOINTS.MED]: 180,
  [BREAKPOINTS.HIGH]: 200,
};
class IssueDescription extends Component {
  constructor(props) {
    super(props);

    this.state = {
      description: "",
      internalTicketReference: "",
      attachmentModalOpen: false,
      attachments: [],
      attachmentErrors: [],
      phase: PHASE.NOT_STARTED,
    };
  }

  getImage = (priority) => {
    if (priority === "low") {
      return LowPrioritySelected;
    } else if (priority === "high") {
      return HighPrioritySelected;
    } else {
      return MediumPrioritySelected;
    }
  };
  onChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  saveAttachments = (attachments, phase) => {
    const { attachments: existingAttachments } = this.state;
    if (phase !== "remove") {
      const filteredArray = [];
      attachments.forEach((attachment) => {
        if (
          existingAttachments.some(
            (existingAttachment) => existingAttachment.id === attachment.id
          )
        ) {
        } else {
          filteredArray.push(attachment);
        }
      });
      this.setState({ attachments: existingAttachments.concat(filteredArray) });
    } else {
      this.setState({ attachments });
    }
  };
  componentDidMount() {
    const { data } = this.props;

    if (data.issue && data.issue.description) {
      this.setState({ description: data.issue.description });
    }
    if (data.issue && data.issue?.internalTicketReference) {
      this.setState({
        internalTicketReference: data.issue?.internalTicketReference,
      });
    }
    if (data.issue && data.issue.attachments) {
      this.setState({ attachments: data.issue.attachments });
    }
  }

  render() {
    const {
      onSelect,
      closeModal,
      data,
      breakpoint,
      auth_status,
      location,
      auth_status: { user },
    } = this.props;
    const { description, attachments, phase, internalTicketReference } =
      this.state;
    const enabled = description.length >= 50;
    const priority = data.priority ? data.priority : "MEDIUM";
    const tour = location?.state?.tour;
    const isEnabled = enabled || tour ? true : false;

    return (
      <div className="issue-description-container">
        <div
          className="issue-description-section"
          id="active_field_dynamic_container"
        >
          <div className={`priority ${priority}`}>
            <div className="icon">
              <img src={this.getImage(priority)} />
            </div>
            <div className="priority-level">
              <div className="text buttons10">{`${priority} PRIORITY`}</div>
            </div>
          </div>
          <TextInput
            placeholder="Please be as descriptive as possible."
            type={INPUT_TYPES.TEXTAREA}
            label="ISSUE Description"
            name="description"
            value={data.description ? data.description : description || ""}
            onChange={this.onChange}
            characterMinLength={50}
            showCharacterCount={true}
            active={true}
            setDefaultValueAsPlaceholder
            minMessage={true}
            maxTextAreaHeight={MAX_TEXT_AREA_HEIGHT[breakpoint]}
            breakpoint={breakpoint}
            cypressId="issue-description-textarea"
            id="issue-description-textarea"
          />
        </div>
        {user?.sharedUser && (
          <div className="internal-ticket-reference">
            <TextInput
              placeholder=""
              type={INPUT_TYPES.INPUT}
              label="Internal Ticket Reference"
              name="internalTicketReference"
              value={
                data.internalTicketReference
                  ? data.internalTicketReference
                  : internalTicketReference || ""
              }
              onChange={this.onChange}
              active={true}
              hideCheckmark
              breakpoint={breakpoint}
              cypressId="internal-ticket-reference"
            />
          </div>
        )}
        <div className="attachment-section">
          <UploadSection
            saveAttachments={this.saveAttachments}
            phase={phase}
            attachments={attachments}
            auth_status={auth_status}
          />
        </div>
        <div className="buttons-row">
          <div className="cancel-button">
            <BloxButton
              title="CANCEL"
              enabled={true}
              customClass="blox-button-swipe"
              onClick={closeModal}
              id="cancel-button-swipe"
              cypressId="issue-description-cancel"
            />
          </div>
          <div className="next-button">
            <BloxButton
              title="NEXT"
              id="next-issue-description"
              enabled={isEnabled}
              customClass={
                enabled ? "blox-button-swipe active" : "blox-button-swipe"
              }
              cypressId="issue-description-next"
              onClick={() => {
                onSelect(
                  "issue",
                  {
                    data: { description, attachments, internalTicketReference },
                  },
                  true
                );
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}
IssueDescription.propTypes = {
  data: object,
  onSelect: func,
};

IssueDescription.defaultProps = {
  data: { priority: "MEDIUM", description: null },
  onSelect: () => {},
};

export default IssueDescription;
